export default __webpack_public_path__ + "static/media/ecosystem-members-link-img4-mob.817b3101.png";